<script>
import { debounce } from '@/helpers/debounce'
import McButton from '@/components/McButton'
import McCheckbox from '@/components/McCheckbox'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    McButton,
    Multiselect,
    McCheckbox,
  },
  mixins: [Helper],
  props: {
    fields: {
      type: Array,
      required: true,
    },
    apiClient: {
      type: Object,
      required: true,
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    limitOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
    hasDelete: {
      type: Boolean,
      default: true,
    },
    bulkDeleteApi: {
      type: Boolean,
      default: false,
    },
    refreshData: {
      type: Boolean,
      default: false,
    },
    customHandlers: {
      type: Object,
      default: () => {},
    },
    searchable: {
      type: Boolean,
    },
    busy: {
      type: Boolean,
    },
    withCard: {
      type: Boolean,
    },
    hasCheckbox: {
      type: Boolean,
      default: true,
    },
    hasSelectAll: {
      type: Boolean,
      default: true,
    },
    stickyHeader: {
      type: Boolean,
    },
    isSelectableField: {
      type: Boolean,
    },
    hasStore: {
      type: Object,
      default: () => {},
    },
    checkType: {
      type: String,
      default: 'multiple',
    },
    hasDisabled: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    stickyCheckbox: {
      type: Boolean,
      default: true,
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    customButton: {
      type: Boolean,
    },
    hasMassSelect: {
      type: Boolean,
      default: false,
    },
    isTextWrap: {
      default: false,
      type: Boolean,
    },
    activeFilters: {
      type: Object,
      default: () => {},
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cardPadding: {
      type: Boolean,
      default: true,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    hasBilingual: {
      type: Boolean,
      default: false,
    },
    lazyLoadAddress: {
      type: Boolean,
      default: false,
    },
    reportKey: {
      type: String,
      default: '',
    },
    customToast: {
      type: Function,
      default: null,
    },
    displayDeleteBy: {
      type: String,
      default: '',
    },
    customDelete: {
      type: Boolean,
      default: false,
    },
    emptyButton: {
      type: Boolean,
      default: false,
    },
    filterBottom: {
      type: Boolean,
      default: false,
    },
    itemProperty: {
      type: String,
      default: '',
    },
    singleSort: {
      type: Boolean,
      default: false,
    },
    hasGraph: {
      type: Boolean,
      default: false,
    },
    isSearchWithFilter: {
      type: Boolean,
      default: false,
    },
    hasFilterV2: {
      type: Boolean,
      default: false,
    },
    deleteObject: {
      type: String,
      default: '',
    },
    rowClass: {
      type: Function,
      default: () => {},
    },
    transformDataKey: {
      type: String,
      default: '',
    },
    transformDataID: {
      type: String,
      default: '',
    },
    clientSidePagination: {
      type: Boolean,
      default: false,
    },
    hideCountData: {
      type: Boolean,
      default: false,
    },
    hideGoToFirstLastPagination: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: true,
    },
    initialPage: {
      type: Number,
      default: 1,
    },
    initialLimit: {
      type: Number,
      default: 10,
    },
    initialSearch: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show_model: [],
      page: this.initialPage,
      limit: this.initialLimit,
      totalCount: 0,
      isBusy: true,
      search: this.initialSearch,
      sorts: [],
      items: [],
      ids: [],
      rowUpdate: {},
      selectedIds: {},
      selectedIdsLength: 0,
      selectedAll: false,
      dataFields: this.cloneFields(this.fields),
      dataColumns: this.cloneColumns(this.fields),
      selectedName: null,
      selectedNames: {},
      isTable: true,
      dataGraph: {},
      initialFields: this.fields,
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    startData() {
      return this.limit * this.page - this.limit + 1
    },
    endData() {
      const _endData = this.limit * this.page
      return this.totalCount < _endData ? this.totalCount : _endData
    },
    showedFields() {
      return [...this.fields]
    },
    computedFields() {
      const fields = this.dataFields?.filter((field) => field.shown)

      if (this.hasCheckbox) {
        if (!fields.find((item) => item.key == 'checkbox')) {
          fields.unshift({
            key: 'checkbox',
            label: '',
            stickyColumn: this.stickyCheckbox,
          })
        }
      }
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return fields.filter(function (item) {
          return item.key == 'checkbox' || result.includes(item.key)
        })
      } else {
        return fields
      }
    },
    classTable() {
      const textWrap = !this.isTextWrap ? 'text-nowrap' : ''
      return `table-responsive ${textWrap} border border-1 mc-table-overflow`
    },
    address() {
      return this.$store.state.map.address
    },
    childFields() {
      const filteredData = this.fields.filter((obj) => {
        return Object.prototype.hasOwnProperty.call(obj, 'children')
      })
      return filteredData
    },
  },
  watch: {
    async locale() {
      this.dataFields = this.cloneFields(this.fields)

      if (this.hasBilingual) {
        await this.getData({
          limit: this.limit,
          page: this.page,
          search: this.search != '' ? this.search : undefined,
        })
      }
    },
    refreshData: {
      async handler(val) {
        if (val) {
          this.selectedIds = []
          this.selectedAll = false
          this.selectedIdsLength = 0
          await this.getData({
            limit: this.limit,
            page: 1,
            search: this.search != '' ? this.search : undefined,
          })
        }
      },
      deep: true,
      immediate: true,
    },
    activeFilters() {
      this.getData({
        limit: this.limit,
        page: 1,
        search: this.search != '' ? this.search : undefined,
      })
    },
  },
  async mounted() {
    await this.$nextTick()
    await this.getData(
      {
        limit: this.limit,
        page: this.page,
        search: this.search != '' ? this.search : undefined,
      },
      true
    )
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    async generateAddressReport() {
      const finalFields = this.deepClone(this.fields, 'child')
      const column =
        this.reportKey != 'vehicle-offline'
          ? finalFields.map((field) => field.header)
          : finalFields.map((field) => field.key)
      const address = this.address
      const { data, newAddress } = await this.generateAddress(
        address,
        this.items,
        this.reportKey,
        column
      )
      newAddress.forEach((item) => {
        this.$store.commit('map/SET_ADDRESS_INFO', item)
      })
    },

    showDeleteModal() {
      this.$refs['mc-modal-delete'].show()
    },

    deepClone(fields, level) {
      const finalFields = []

      fields.forEach((field) => {
        if (level == 'parent') {
          finalFields.push(field)
        } else {
          if (Object.hasOwn(field, 'children')) {
            finalFields.push(...field.children)
          } else {
            finalFields.push(field)
          }
        }
      })
      return finalFields
    },

    cloneFields(fields) {
      const finalFields = this.deepClone(fields, 'child')
      finalFields.forEach((item) => {
        if (item.shown === undefined) item.shown = true
      })
      return finalFields
    },

    cloneColumns(fields) {
      const finalFields = this.deepClone(fields, 'parent')
      finalFields.forEach((item) => {
        if (item.shown === undefined) item.shown = true
      })
      return finalFields
    },

    stringSorts() {
      const arr = this.sorts.map((sort) => {
        const obj = {
          [sort.key]: sort.order,
        }
        return JSON.stringify(obj)
      })

      return arr
    },
    // TECHDEBT: Only supports resourceful format
    // getData methods can be improved to support user-supplied data
    async getData(opts, refresh = false) {
      try {
        if (!this.apiClient?.get) {
          this.isBusy = false
          return
        }

        const filter = {
          pagination: {
            page: opts.page,
            show: opts.limit,
          },
          orderBy: opts.sorts,
          search: opts.search,
        }

        if (filter?.orderBy && !filter.orderBy.length) delete filter.orderBy
        if (filter?.search && !filter.search) delete filter.search

        this.isBusy = true
        const res = await this.apiClient.get(filter)
        if (!res) {
          this.isBusy = false
          return
        }
        this.items =
          this.transformDataKey && this.itemProperty
            ? res.data
            : this.transformDataKey
            ? res.data.map((item) => ({
                ...item,
                [this.trackBy]: item[this.transformDataKey]?.[this.transformDataID],
              }))
            : this.itemProperty
            ? res.data[this.itemProperty]
            : res.data

        const getIds = (datas) => {
          if (this.hasDisabled) {
            let allIds = []
            datas.map((item) => {
              if (!item.ssgroupId && !this.customHandlers.handleDisabledRow(item)) {
                allIds.push(item[this.trackBy])
              }
            })
            return [...new Set(allIds)]
          } else return datas.map((x) => x[this.trackBy])
        }

        if (this.hasMassSelect && !opts.search) {
          const allFilter = {
            pagination: {
              page: 1,
              show: 9999,
            },
            search: opts.search,
          }
          const allRes = await this.apiClient.get(allFilter)
          const items =
            this.transformDataKey && this.itemProperty
              ? allRes.data
              : this.transformDataKey
              ? allRes.data.map((item) => ({
                  ...item,
                  [this.trackBy]: item[this.transformDataKey]?.[this.transformDataID],
                }))
              : this.itemProperty
              ? allRes.data[this.itemProperty]
              : allRes.data

          this.ids = getIds(items)
        } else this.ids = getIds(this.items)

        this.page = res.pagination.page ? res.pagination.page : 1
        this.totalCount = res.pagination.total

        if (this.items.length === 0 && !this.search) {
          this.$emit('available-change', false)
        }

        this.isBusy = false

        if (this.lazyLoadAddress) {
          await this.generateAddressReport()
        }

        if (this.hasGraph && refresh) {
          const data = await this.apiClient.getGraph()
          this.dataGraph = data
        }
      } catch (error) {
        this.$mcToast.error(error?.message ?? this.$t('global.somethingWentWrong'))
        console.log(error)
      }
    },

    handleSearchChange: debounce(async function (_search) {
      this.search = _search
      this.$emit('update:search', _search)
      const opts = {
        limit: this.limit,
        search: _search != '' ? _search : undefined,
        page: 1,
        sorts: this.stringSorts(),
      }
      await this.getData(opts)
      this.$refs['searchInput'].$el.focus()
    }, 500),

    handleClearSearch() {
      this.handleSearchChange(undefined)
      this.search = ''
      this.$emit('update:search', '')
    },

    async handleLimitChange(_limit) {
      this.limit = _limit
      this.$emit('update:limit', _limit)

      await this.getData({
        limit: _limit,
        search: this.search != '' ? this.search : undefined,
        page: 1,
        sorts: this.stringSorts(),
      })
    },

    async handlePageChange(newPage) {
      this.page = newPage
      this.$emit('update:page', newPage)
      const opts = {
        page: newPage,
        search: this.search != '' ? this.search : undefined,
        limit: this.limit,
        sorts: this.stringSorts(),
      }
      await this.getData(opts)
    },

    async handleSortChange(data) {
      // If this function is called without data params,
      // remove sorting (revert to default)
      if (!data) {
        this.sorts = []
        return
      }

      // If field not sortable or If currently editing a field, disable sort
      if (!data?.field?.isSortable) return

      // Get index of current column sort, if any
      const currentColumnSortIndex = this.sorts.findIndex(
        (sort) => sort.key === (data.field.sortKey ?? data.field.key)
      )
      // Get the sorting data (key, order)
      const currentColumnSort = this.sorts[currentColumnSortIndex]
      let newSorts = [...this.sorts]
      // This switch case is used to toggle between these conditions:
      // default - asc - desc - default (repeat)
      switch (currentColumnSort?.order) {
        case 'asc':
          newSorts[currentColumnSortIndex] = {
            key: currentColumnSort.key,
            order: 'desc',
          }
          break

        case 'desc':
          newSorts.splice(currentColumnSortIndex, 1)
          break

        default:
          // If it have single sort, remove all other sorts
          if (this.singleSort) newSorts = []
          newSorts.push({ key: data.field.sortKey ?? data.field.key, order: 'asc' })
          break
      }

      this.sorts = [...newSorts]

      await this.$nextTick()

      return this.getData({
        limit: this.limit,
        page: 1,
        search: this.search != '' ? this.search : undefined,
        sorts: this.stringSorts(),
      })
    },

    async handleDelete() {
      const _selected = Object.keys(this.selectedIds).filter((key) => this.selectedIds[key] == true)
      this.isBusy = true
      const promises = []

      if (this.bulkDeleteApi) {
        this.deleteBulk(_selected)
        return
      }

      if (!this.apiClient.delete) {
        this.$store.commit(this.hasStore.delete, _selected)
        this.handleUnselectAll()
        setTimeout(() => {
          this.getData({
            limit: this.limit,
            page: 1,
            sorts: this.stringSorts(),
          })
          this.$refs['mc-modal-delete'].hide()
        }, 300)
      } else {
        _selected.forEach((el) => {
          promises.push(this.apiClient.delete(el))
        })

        await Promise.all(promises).then((res) => {
          if (this.search) this.handleClearSearch()
          this.handleUnselectAll()
          setTimeout(() => {
            this.getData({
              limit: this.limit,
              page: 1,
              sorts: this.stringSorts(),
            })
            this.$refs['mc-modal-delete'].hide()
            res.forEach((result) => {
              if (result) this.$mcToast.success(this.$t('global.alert.text.delete'))
              else {
                if (this.customToast) {
                  this.customToast()
                } else {
                  this.$mcToast.error({
                    component: 'McToastDynamicBody',
                    props: {
                      contents: [
                        {
                          tag: 'h6',
                          text: this.$t('maintenance.alert.deleteFailed'),
                        },
                        {
                          tag: 'p',
                          text: this.$t('global.alert.text.failedDelete'),
                        },
                      ],
                    },
                  })
                }
              }
            })
          }, 300)
        })
      }
    },

    handleAdd() {
      if (this.customHandlers?.handleAdd) this.customHandlers.handleAdd()
    },

    handleSelect(checked, data) {
      if (this.checkType === 'single') {
        this.selectedIds = { [data.item[this.trackBy]]: true }
        this.selectedIdsLength = 1
      } else {
        this.selectedIds = { ...this.selectedIds, [data.item[this.trackBy]]: checked }
        if (this.customDelete) {
          this.selectedNames = { ...this.selectedNames, [data.item[this.displayDeleteBy]]: checked }
          for (const name in this.selectedNames) {
            if (this.selectedNames[name] === true) {
              this.selectedName = name
              break
            }
          }
        }

        if (checked) {
          let flag = true
          const selectedKeys = Object.keys(this.selectedIds).filter((key) => this.selectedIds[key])
          for (const iterator of this.ids) {
            let index = selectedKeys.indexOf(iterator.toString())
            if (index == -1) {
              flag = false
              break
            }
          }
          if (flag) this.selectedAll = true
          else this.selectedAll = false
          this.selectedIdsLength += 1
        } else {
          this.selectedAll = false
          this.selectedIdsLength -= 1
        }
      }

      this.$emit('totalSelected', this.selectedIdsLength)
      this.$emit('handleSelectValue', this.selectedIds)
    },

    handleSelectAll(event) {
      if (event) {
        this.selectedIds = Object.fromEntries(this.ids.map((key) => [key, true]))
        this.selectedIdsLength = this.ids.length

        this.selectedAll = true

        this.$emit('totalSelected', this.selectedIdsLength)
        this.$emit('handleSelectValue', this.selectedIds)
      } else {
        this.handleUnselectAll()
      }
    },

    handleUnselectAll() {
      this.selectedIds = {}
      this.selectedAll = false
      this.selectedIdsLength = 0
      this.$emit('totalSelected', 0)
      this.$emit('handleSelectValue', {})
    },

    handleClickRow(field, item) {
      if (field.isRedirectable && this.customHandlers?.handleClickRow)
        this.customHandlers.handleClickRow(item)
    },

    handleSetDataFields(fields) {
      this.dataFields = this.cloneFields(fields)
      this.dataColumns = this.cloneColumns(fields)
    },

    showSortIcon(data, order) {
      const currentColumnSort = this.sorts.find(
        (sort) => sort.key === (data.field.sortKey ?? data.field.key)
      )
      if (!currentColumnSort) {
        return true
      }

      return (
        currentColumnSort.key === (data.field.sortKey ?? data.field.key) &&
        currentColumnSort.order === order
      )
    },

    async deleteBulk(ids) {
      if (this.search) this.handleClearSearch()
      this.handleUnselectAll()
      this.$refs['mc-modal-delete'].hide()
      this.selectedNames = {}
      this.selectedName = null
      const res = await this.apiClient.delete(ids)
      const deletedCount =
        typeof res === 'object' && Number.isFinite(res.count) ? res.count : null
      const requestData = {
        limit: this.limit,
        page: 1,
        sorts: this.stringSorts(),
      }

      setTimeout(() => {
        if (res) {
          this.getData(requestData)
          this.$mcToast.success(
            deletedCount === null
              ? this.$t('global.alert.text.delete')
              : `${deletedCount} ${this.$t('global.alert.text.delete')}`
          )
        } else {
          this.getData(requestData)
          this.$mcToast.error({
            component: 'McToastDynamicBody',
            props: {
              contents: [
                {
                  tag: 'h6',
                  text: this.$t('maintenance.alert.deleteFailed'),
                },
                {
                  tag: 'p',
                  text: this.$t('global.alert.text.failedDelete'),
                },
              ],
            },
          })
        }
      }, 300)
    },

    changeTable(bool) {
      this.isTable = bool
      this.$emit('handleTableChanged', bool)
    },
  },
}
</script>

<template>
  <!-- TECHDEBT: add functionality to provide filter, per-page, etc from props -->
  <div class="mc-table" :class="{ 'has-checkboxes': hasCheckbox }">
    <slot
      v-if="hasFilter"
      name="button-filter"
      :showDeleteModal="showDeleteModal"
      :isSelected="selectedIdsLength"
      :selectedIds="selectedIds"
    />
    <div class="clearfix mb-3">
      <div class="float-start d-flex">
        <slot name="title" />
      </div>

      <div v-if="!isEmpty || (isEmpty && search) || emptyButton" class="float-end d-flex">
        <slot
          v-if="selectedIdsLength || customButton"
          name="button-header"
          :selectedIdsLength="selectedIdsLength"
        />
        <McButton
          v-if="selectedIdsLength && hasDelete"
          variant="secondary-red"
          :text="$t('global.delete')"
          icon="icon-outline_trash"
          class="mx-2 mb-2 ms-auto"
          @click="showDeleteModal"
        />
        <slot name="custom-btn" />
        <McButton
          v-if="typeof customHandlers?.handleAdd !== 'undefined'"
          variant="primary"
          class="mb-2 ms-auto"
          :disabled="isBusy || busy"
          :text="$t('global.create')"
          icon="icon-fill_plus"
          @click="handleAdd"
        />
        <slot v-if="customButton" name="button-value-help" />
      </div>
    </div>
    <div v-if="filterBottom" class="pb-3">
      <slot
        name="button-filter"
        :showDeleteModal="showDeleteModal"
        :isSelected="selectedIdsLength"
        :selectedIds="selectedIds"
      />
    </div>

    <div :class="{ card: withCard, 'p-4': cardPadding }">
      <div :class="withCard ? 'card-body' : ''">
        <b-row v-if="!isEmpty || (isEmpty && search)">
          <slot name="tab-button" :handleUnselectAll="handleUnselectAll" />
        </b-row>
        <b-row>
          <b-col v-if="hasGraph" md="4" class="mc-row-check-wrapper">
            <b-button-group>
              <McButton
                :variant="isTable ? 'primary' : 'secondary'"
                icon="icon-outline_browser"
                text="Table"
                @click="changeTable(true)"
              />
              <McButton
                :variant="isTable ? 'secondary' : 'primary'"
                icon="icon-fill_activity"
                :text="$t('delivery.text.chart')"
                @click="changeTable(false)"
              />
            </b-button-group>
          </b-col>
          <b-col v-if="isSelectable" md="4" class="mc-row-check-wrapper">
            <h6 v-if="selectedIdsLength" class="mc-row-check mt-0">
              <span class="badge btn-success">{{ selectedIdsLength }}</span>
              {{ $t('global.object.selectedRow') }}
              <a class="color-primary" @click="handleUnselectAll">
                {{ $t('global.action.deselect') }}
              </a>
            </h6>
          </b-col>
          <slot name="additionalFilter" />
          <b-col :md="hasGraph ? 4 : 8" class="flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view d-flex flex-row-reverse">
              <b-input-group
                v-if="(searchable && !isEmpty) || (isEmpty && search)"
                size="sm"
                class="mc-has-search"
                :class="{ isSearchWithFilterStyle: isSearchWithFilter }"
                @click="focusSearch"
              >
                <template #prepend>
                  <i class="ps-2 mc-icon icon-fill_search" />
                </template>
                <b-form-input
                  ref="searchInput"
                  :placeholder="$t('global.search') + '...'"
                  :value="search"
                  @input="handleSearchChange"
                />
                <template v-if="search" #append>
                  <button
                    class="clear-search-btn"
                    :disabled="isBusy || busy"
                    @click="handleClearSearch"
                  >
                    <i class="pe-2 mc-icon icon-outline_close" />
                  </button>
                </template>
              </b-input-group>

              <slot
                v-if="isTable && !isEmpty"
                name="viewManager"
                :handleSetDataFields="handleSetDataFields"
                :dataFields="dataFields"
                :initialFields="initialFields"
                :dataColumns="dataColumns"
              />

              <div v-if="isSelectableField">
                <p class="mc-label">
                  {{ $t('global.action.show') }}
                </p>
                <multiselect
                  id="fieldColumnShow"
                  ref="show_model"
                  v-model="show_model"
                  :options="showedFields"
                  :multiple="true"
                  :placeholder="$t('global.object.allColumn')"
                  track-by="label"
                  label="label"
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <div v-if="isLoading">
          <div class="loading-container">
            <div class="__busy d-flex align-items-center justify-content-center">
              <b-spinner class="align-middle mb-2" />
            </div>
          </div>
        </div>

        <div v-if="!isTable && hasGraph" class="mt-4">
          <slot name="graphic" :dataGraph="dataGraph" />
        </div>
        <div
          v-if="((!isLoading && !isEmpty) || (isEmpty && search)) && isTable"
          :class="classTable"
        >
          <b-table
            :sticky-header="stickyHeader"
            :busy="isBusy"
            :items="items"
            :fields="computedFields"
            :per-page="limit"
            fixed
            show-empty
            :tbody-tr-class="rowClass"
            :class="{ 'b-table': true, 'table-bordered': hasBorder }"
            v-bind="clientSidePagination ? { 'current-page': page } : {}"
          >
            <!-- Loading -->
            <template #table-busy>
              <div class="__busy">
                <b-spinner class="align-middle mb-2" />
                <strong>{{ $t('global.text.loading') }}...</strong>
              </div>
            </template>

            <!-- Empty Result -->
            <template #empty>
              <div class="text-center my-4">
                {{ $t('global.text.noData') }}
              </div>
            </template>

            <!-- Slot: Header Checkbox -->
            <template v-if="hasSelectAll && checkType === 'multiple'" #head(checkbox)>
              <McCheckbox
                v-model="selectedAll"
                :disabled="isBusy || ids.length === 0 || busy"
                @change="handleSelectAll"
              />
            </template>

            <template v-if="childFields.length > 0" #thead-top="data">
              <tr>
                <template v-for="(field, index) in data.fields">
                  <th v-if="!Object.hasOwn(field, 'childOfIndex')" :id="field.key" :key="field.key">
                    <span class="sr-only" />
                  </th>
                  <th
                    v-else-if="field.isTopHead"
                    id="sub-header"
                    :key="field.key + '-' + index"
                    style="text-align: center"
                    :colspan="childFields[field.childOfIndex].headerColspan"
                  >
                    {{ $t(childFields[field.childOfIndex].label) }}
                    {{ childFields[field.childOfIndex].labelValue }}
                  </th>
                </template>
              </tr>
            </template>

            <!-- Slot: Header Data -->
            <template #head()="data">
              <div @click="handleSortChange(data)">
                {{ $t(data.label) }} {{ data.labelValue }}
                <template v-if="data.field.isSortable">
                  <div v-if="showSortIcon(data, 'asc')" class="sort-icon-up">
                    <i class="mc-icon icon-outline_chevron-up" />
                  </div>
                  <div v-if="showSortIcon(data, 'desc')" class="sort-icon-down">
                    <i class="mc-icon icon-outline_chevron-down" />
                  </div>
                </template>
              </div>
            </template>

            <!-- Slot: Cell Checkbox -->
            <template #cell(checkbox)="data">
              <div v-if="checkType === 'single'" class="form-check">
                <input
                  name="radio-table"
                  type="radio"
                  class="custom-control-input"
                  :disabled="
                    isBusy || hasDisabled
                      ? customHandlers.handleDisabledRow(data.item)
                      : null || busy
                  "
                  :checked="selectedIds[data.item[trackBy]]"
                  @change="(event) => handleSelect(event, data)"
                />
              </div>
              <McCheckbox
                v-else
                v-model="selectedIds[data.item[trackBy]]"
                :disabled="
                  isBusy || hasDisabled ? customHandlers.handleDisabledRow(data.item) : null || busy
                "
                @change="(event) => handleSelect(event, data)"
              />
            </template>

            <!-- Slot: Cells on first column -->
            <template
              v-if="fields[0].key != 'checkbox' && !fields[0].isObject"
              #[`cell(${fields[0].key})`]="{ index, field, value, item }"
            >
              <div
                :class="{
                  'fw-bold text-primary td__noellipsis': !field.isRedirectable ? false : true,
                  'clickable-field': field.isRedirectable,
                }"
                :title="value"
                @click="handleClickRow(field, item)"
              >
                {{ value }}
              </div>
            </template>

            <template
              v-if="hasCheckbox"
              #[`cell(${computedFields[1].key})`]="{ index, field, value, item }"
            >
              <div
                v-if="field.isShortable"
                :class="{
                  'fw-bold text-primary td__noellipsis': !field.isRedirectable ? false : true,
                  'clickable-field': field.isRedirectable,
                }"
                :title="value"
                @click="handleClickRow(field, item)"
              >
                {{
                  value.length > field.shortableLength
                    ? value.substring(0, field.shortableLength)
                    : value
                }}
                <i
                  v-if="value.length > field.shortableLength"
                  v-b-tooltip.hover
                  class="mc-fa icon-fill_more-horizontal"
                  :title="value"
                />
              </div>
              <div
                v-else
                :class="{
                  'fw-bold text-primary td__noellipsis': !field.isRedirectable ? false : true,
                  'clickable-field': field.isRedirectable,
                }"
                :title="value"
                @click="handleClickRow(field, item)"
              >
                {{ value }}
              </div>
            </template>

            <!-- Slot: All Cells -->
            <template #cell()="{ index, field, value, item }">
              <template v-if="typeof value === 'number'">
                <div class="td__overflow-ellipsis" :title="value">
                  {{ value.toLocaleString() }}
                </div>
              </template>

              <template v-else>
                <div v-if="field.isShortable">
                  {{
                    value.length > field.shortableLength
                      ? value.substring(0, field.shortableLength)
                      : value
                  }}
                  <i
                    v-if="value.length > field.shortableLength"
                    v-b-tooltip.hover
                    class="mc-fa icon-fill_more-horizontal"
                    :title="value"
                  />
                </div>
                <div v-else class="td__overflow-ellipsis" :title="value">
                  {{ value }}
                </div>
              </template>
            </template>

            <!-- Slot: Slot override from parent component -->
            <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
              <slot :name="name" v-bind="data" />
            </template>
          </b-table>
        </div>

        <div v-else-if="isLoading" />
        <div v-else-if="isEmpty && !search">
          <slot name="emptyState" />
        </div>
        <div v-if="showPagination && !isEmpty && isTable" class="d-flex flex-wrap flex-md-nowrap">
          <div class="mc-limit">
            <div class="__limit">
              {{ $t('global.text.displays') }}
              <b-form-select
                class="form-select form-select-sm __limit--dropdown"
                size="sm"
                :disabled="isBusy"
                :options="limitOptions"
                :value="limit"
                @input="handleLimitChange"
              />
              <div>{{ $t('global.text.data') }}</div>
            </div>

            <div class="__info">
              <strong>{{ startData }}</strong> - <strong>{{ endData }}</strong>
              <template v-if="!hideCountData">
                {{ $t('global.object.of') }} <strong>{{ totalCount }}</strong>
                {{ $t('global.text.data') }}
              </template>
            </div>
          </div>
          <div class="mc-pagination-container">
            <b-pagination
              v-if="!clientSidePagination"
              :disabled="isBusy"
              :per-page="limit"
              :total-rows="totalCount"
              :value="page"
              :hide-goto-end-buttons="hideGoToFirstLastPagination"
              @change="handlePageChange"
            />
            <b-pagination
              v-else
              v-model="page"
              :total-rows="totalCount"
              :per-page="limit"
              :hide-goto-end-buttons="hideGoToFirstLastPagination"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mc-modal-delete"
      ref="mc-modal-delete"
      class="mc-modal"
      :title="deleteObject ? `${$t('global.delete')} ${deleteObject}` : $t('global.delete')"
      size="md"
      centered
      scrollable
    >
      <div v-if="customDelete" class="card-body p-2">
        <p v-if="selectedIdsLength === 1">
          {{ $t('global.confirmDelete') }} <strong class="bold">{{ selectedName }}</strong> ?
        </p>
        <p v-else>
          {{ $t('global.confirmDelete') }}
          <strong class="bold">{{ selectedIdsLength }} {{ $t('global.object.data') }}</strong>
          {{ $t('global.selected') }}?
        </p>
      </div>
      <div v-else class="card-body p-2">
        <p v-if="deleteObject">
          {{
            $t('global.modalDelete', {
              count: selectedIdsLength,
              object: deleteObject.toLowerCase(),
            })
          }}
        </p>
        <p v-else>
          {{ $t('global.confirmDelete1') }} <strong>{{ selectedIdsLength }}</strong>
          {{ $t('global.confirmDelete2') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            :text="
              deleteObject
                ? `${$t('global.action.cancel')} ${$t('global.delete')}`
                : $t('global.action.cancel')
            "
            class="me-2"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            :text="
              deleteObject
                ? `${$t('global.yes')}, ${$t('global.delete')} ${deleteObject}`
                : $t('global.delete')
            "
            @click="handleDelete"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
@import './style.scss';
</style>
